import { useNavigate } from "react-router-dom";
import styles from "./PurchaseHistoryList.module.css";
const PurchaseHistoryList = ({ data }) => {
  console.log("Data", data);
  const navigate = useNavigate();
  while (data.length < 3) {
    data.push({
      date: "",
      count: "",
      amount: "",
    });
  }

  return (
    <div className={styles.visit_history_list_container}>
      {Array.isArray(data) &&
        data.length > 0 &&
        data.map((item, index) => {
          if (item.date === "") {
            return <div key={index} className={styles.single_row}></div>;
          }
          return (
            <div key={index} className={styles.single_row}>
              <div className={styles.ctn1}>
                <div>購入日</div>
                <div className={styles.tag1}>{item.date}</div>
              </div>
              <div className={styles.ctn1}>
                <div>点数</div>
                <div className={styles.tag2}>{item.quantity}</div>
              </div>
              <div className={styles.ctn1}>
                <div>商品合計金額</div>
                <div className={styles.tag3}>
                  {new Intl.NumberFormat("ja-JP", {
                    style: "currency",
                    currency: "JPY",
                  }).format(item.amount)}
                </div>
              </div>

              <div
                className={styles.btn1}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate("/purchase-history/details?id=" + item.id)
                }
              >
                詳細
              </div>
            </div>
          );
        })}
    </div>
  );
};
export default PurchaseHistoryList;
